const parameterize = require('./parameterize')

const createLabPageSlug = (name, id) =>
  `/labs/diagnostic-tests/${parameterize(name)}-${id}/`

const createPackagePageSlug = (name, id) =>
  `/labs/packages/${parameterize(name)}-${id}/`

const getSlugFunction = name => {
  switch (name) {
    case 'PorteaLabLabTestNode':
      return createLabPageSlug
    case 'PorteaLabPackageNode':
      return createPackagePageSlug
    default:
      return null
  }
}

module.exports = getSlugFunction
